<template>
  <div class="container">
    <!-- 加载状态 -->
    <QrcodePopup :qr-info="qrCodeInfo" />

    <div v-if="isLoading" class="loading-state">
      <p>加载中...</p>
    </div>

    <!-- 新闻内容 -->
    <div v-else-if="newsItem?.content" class="news-page">
      <h1 class="news-title">{{ newsItem.title }}</h1>
      <div class="news-meta">
        <span
          class="news-author"
          @mouseenter="enterChat"
          @mouseleave="leaveChat"
        >
          作者：成都北新医院
        </span>
        <span class="news-date">{{ formatDate(newsItem.date) }}</span>
        <span v-if="newsItem.views" class="news-views"
          >浏览 {{ newsItem.views }} 次</span
        >
      </div>
      <div class="news-content" v-html="newsItem.content"></div>
    </div>

    <!-- 未找到或错误状态 -->
    <div v-else class="news-page empty-state">
      <h1>未找到新闻</h1>
      <p>该新闻不存在或已被删除。</p>
      <button @click="goBack" class="back-btn">返回列表</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useNewsStore, type NewsType } from "@/stores/news";
import { useRouter } from "vue-router";
import QrcodePopup from "@/components/QrcodePopup/index.vue";

const newsStore = useNewsStore();
const showwechat = ref(false);
const enterChat = () => {
  showwechat.value = true;
};
const leaveChat = () => {
  showwechat.value = false;
};

const isLoading = ref(false);
const newsItem = ref<NewsType | null>(null);
const qrCodeInfo = ref([
  {
    visible: showwechat,
    title: "扫描关注医院公众号",
    imageSrc: "/Other/公众号.jpg",
    altText: "公众号",
  },
]);
/**
 * 格式化日期
 */
const formatDate = (dateString?: string): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};
const router = useRouter();
/**
 * 返回列表页
 */
const goBack = () => {
  router.push("/news");
};

// 加载新闻详情
onMounted(async () => {
  Promise.all([newsStore.fetchNewsList()]);
  const id = localStorage.getItem("newsInfoId");
  try {
    isLoading.value = true;

    // 查找新闻
    const found = newsStore.getNewsList.find((item) => item.id === Number(id));
    if (found) {
      newsItem.value = found;
    } else {
      console.warn(`未找到新闻 ID: ${id}`);
      newsItem.value = null;
    }
  } catch (error) {
    console.error("加载新闻失败:", error);
    newsItem.value = null;
  } finally {
    isLoading.value = false;
  }
});
</script>

<style scoped>
@import url("./index.css");
</style>
